import axios from "axios";
import Constants from "../common/constants";

class AuthService {
  baseURL = Constants.API_BASE_URL;

  async login(data) {
    if (!this.validateEmail(data.email)) {
      return Promise.reject("Invalid email address format");
    }

    try {
      const response = await axios.post(`${this.baseURL}/auth/login`, data);

      if (response.data.isActive) {
        this.setCredentials(response);
        return Promise.resolve(response);
      }
    } catch (error) {
      if (!error.response) {
        return Promise.reject("Internal server error");
      }

      const message = error.response.data.message;
      if (message) {
        if (message === "Not verified") {
          this.sendVerificationEmail(data.email);
          return Promise.resolve(false);
        }
        if (
          error.response.status === 500 &&
          message === "An error occurred while processing the request"
        ) {
          return Promise.reject("Пользователь не найден!");
        }
        if (
          error.response.status === 400 &&
          message === "Email or password incorrect. Please try again"
        ) {
          return Promise.reject(
            "Неверный адрес электронной почты или пароль. Пожалуйста, попробуйте снова!"
          );
        }
        return Promise.reject(message);
      }

      return Promise.reject("An error has occured");
    }
  }

  async registration(data) {
    if (!this.validateEmail(data.email)) {
      return Promise.reject("Invalid email address format");
    }

    try {
      const response = await axios.post(
        `${this.baseURL}/auth/registration`,
        data
      );
      this.sendVerificationEmail(data.email);
      return Promise.resolve(response);
    } catch ({ response }) {
      switch (response.status) {
        case 400:
          return Promise.reject("This email is already taken");
        case 500:
          return Promise.reject("Internal server error");
        default:
          return Promise.reject("An error has occured");
      }
    }
  }

  async resetPassword(data) {
    return await axios.post(
      `${this.baseURL}/account-info/reset-password-send-email`,
      data
    );
  }

  async sendVerificationEmail(email) {
    return await axios.post(`${this.baseURL}/auth/send-verification-email`, {
      email,
    });
  }

  validateEmail(email) {
    const regex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(email);
  }

  setCredentials(response) {
    localStorage.setItem("user", JSON.stringify(response.data));
    localStorage.setItem("token", response.headers["jwt-token"]);
  }

  logout() {
    localStorage.removeItem("user");
    localStorage.removeItem("token");

    window.location = "/login";
  }

  isLoggedIn() {
    return !!localStorage.getItem("user") && !!localStorage.getItem("token");
  }

  getCurrentUser() {
    return JSON.parse(localStorage.getItem("user"));
  }
}

export default AuthService;
